import z from 'zod';
import { scopedEntity, alarmRef, userRef } from '../common';
export const alarmPushSubscription = z.object({
    ...scopedEntity.shape,
    alarm: alarmRef,
    user: userRef,
});
